<template>
  <basic-container>
    <section class="section">
      <div class="title">供应商信息</div>
      <div class="content">
        <div class="content_left">
          <div class="content_item">
            <span>{{ getProtocolLabel() }}：</span>
            <span>{{
              protocolOption[detailData.protocol] || '-' }}</span>
          </div>
          <div class="content_item" v-if="detailData.castType !== 'push'">
            <span>房间号：</span>
            <span>{{ detailData.roomNo || '-' }}</span>
          </div>
        </div>
        <div class="content_right">
          <div class="content_item">
            <span>开始时间：</span>
            <span>{{ detailData.createTime || '-' }}</span>
          </div>
          <div class="content_item">
            <span>结束时间：</span>
            <span>{{ detailData.endTime || '-' }}</span>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="title">成员列表</div>
    </section>
    <el-table :data="tableData" border style="width: 100%; margin-top: 10px" v-loading="loading">
      <el-table-column prop="uid" label="uid">
      </el-table-column>
      <el-table-column prop="username" label="用户名">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码">
      </el-table-column>
      <el-table-column prop="dType" label="类型">
        <template slot-scope="scope">
          <span> {{ { 1: 'TV', 2: '安卓', 3: '苹果', 5: 'PC', 7: 'dongle', 8: 'web' }[ parseInt(+scope.row.dType /1000) ] ||  scope.row.dType}}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>

        </template>
      </el-table-column>
    </el-table>
  </basic-container>
</template>
<script>
import protocolOption from "@/config/protocolConfig"
export default {
  data() {
    return {
      tableData: [],
      detailData: {},
      protocolOption:{...protocolOption}
    };
  },
  mounted() {
    this.getDataList();
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/imageManagement/mirrorListDetails') {
          this.getDataList();
        }
      },
      deep: true
    },
  },
  methods: {
    handleClick(row) {

      this.$router.push({
        path: "/imageManagement/mirrorUserDetails",
        query: {
          uri: this.detailData.uri,
          sdkUserId: row.uid,
          dType: row.dType,
          uid: row.uid,
          createTime: this.detailData.createTime,
          roomNo: this.detailData.roomNo,
          castType: this.detailData.castType || 'mirror',
          pdate: this.detailData.pdate,  
          data: JSON.stringify({...row, castType: this.detailData.castType || 'mirror', mimeType: this.detailData.mimeType})
        },
      });
    },

    getDataList() {

      //这个table只会有两条数据，人别是收端跟发端
      // 人上个页面带进来的数据进行拆分
      let data = JSON.parse(this.$route.query.data)
      console.log(data)
      this.tableData = []
      
      // 只有当 sinkUid 和 sinkAppid 都存在时才添加收端数据
      if (data.sinkUid && data.sinkAppid) {
        this.tableData.push({ 
          uid: data.sinkUid, 
          username: data.sinkUsername, 
          mobile: data.sinkMobile, 
          dType: data.sinkDeviceType, 
          isOut: 0, 
          sourceAppName: data.sourceAppName, 
          sinkAppName: data.sinkAppName, 
          ...data 
        });
      }
      
      // 只有当 sourceUid 和 sourceAppid 都存在时才添加发端数据
      if (data.sourceUid && data.sourceAppid) {
        this.tableData.push({ 
          uid: data.sourceUid, 
          username: data.sourceUsername, 
          mobile: data.sourceMobile, 
          dType: data.sourceDeviceType, 
          isOut: 1, 
          sourceAppName: data.sourceAppName, 
          sinkAppName: data.sinkAppName, 
          ...data 
        });
      }
      
      this.detailData = data
    },
    
    // 获取协议标签
    getProtocolLabel() {
      return this.detailData.castType === 'push' ? '投屏协议' : 'RTC供应商';
    },
  },

};
</script>
<style  lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 20px;
}

.section {
  .title {
    color: rgba(16, 16, 16, 100);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    padding-left: 10px;
    position: relative;

    &::before {
      content: "";
      width: 3px;
      height: 15px;
      background: #3c7ee5 100%;
      position: absolute;
      left: 0;
      top: 20%;
    }
  }

  .content {
    width: 100%;
    display: flex;
    background: #f9f7f7;
    padding: 30px 30px 0 30px;
    margin: 10px 0 30px 0;
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: left;
    font-family: SourceHanSansSC-regular;

    .content_left,
    .content_right {
      flex: 1;

      div {
        margin-bottom: 20px;

        span {
          &:first-of-type {
            display: inline-block;
            width: 166px;
          }
        }
      }
    }

    .content_item {
      color: rgba(16, 16, 16, 100);
      font-size: 14px;
      text-align: left;
      font-family: SourceHanSansSC-bold;
    }
  }
}

table {
  tr {

    th,
    td {
      text-align: center !important;
    }
  }
}

._cloud_btn {
  display: inline-block;
  cursor: pointer;
  margin-left: -10px;
  margin-top: 5px;
  padding: 5px 18px;
  color: #61a2d7;
  font-size: 13px;

  &:focus {
    color: pink;
  }
}

/deep/.el-table__row {
  font-size: 12px !important;
}</style>